import { ActivateUserPayload, UserStatus } from '@dev/ee-api/ee-api-models';
import { Action } from 'redux';

export enum ActionTypes {
    ACTIVATE_USER = '@@users/ACTIVATE_USER',
    ACTIVATE_USER_START = '@@users/ACTIVATE_USER_START',
    ACTIVATE_USER_SUCCESS = '@@users/ACTIVATE_USER_SUCCESS',
    ACTIVATE_USER_ERROR = '@@users/ACTIVATE_USER_ERROR',
    CHECK_USER_REGISTRATION = '@@users/CHECK_USER_REGISTRATION',
    CHECK_USER_REGISTRATION_START = '@@users/CHECK_USER_REGISTRATION_START',
    CHECK_USER_REGISTRATION_SUCCESS = '@@users/CHECK_USER_REGISTRATION_SUCCESS',
    CHECK_USER_REGISTRATION_ERROR = '@@users/CHECK_USER_REGISTRATION_ERROR',
}

export interface ActivateUsersAction extends Action {
    type: ActionTypes.ACTIVATE_USER;
    payload: ActivateUserPayload;
    meta: Record<string, unknown>;
}

export interface ActivateUsersStartAction extends Action {
    type: ActionTypes.ACTIVATE_USER_START;
}
export interface ActivateUsersSuccessAction extends Action {
    type: ActionTypes.ACTIVATE_USER_SUCCESS;
    meta: Record<string, unknown>;
}
export interface ActivateUsersErrorAction extends Action {
    type: ActionTypes.ACTIVATE_USER_ERROR;
    payload: Record<string, unknown>;
    meta: Record<string, unknown>;
    error: boolean;
}

export interface UsersState {
    userRegistrationCheck: {
        loading: boolean;
        userStatus?: UserStatus;
        errorMessage?: string;
    };
}

export default UsersState;

export interface CheckIfUserIsActivatedAction extends Action {
    type: ActionTypes.CHECK_USER_REGISTRATION;
    payload: {
        username: string;
        verificationCode: string;
    };
}

export interface UrlSearchParams {
    verification?: string;
    userName?: string;
}

export interface CheckIfUserIsActivatedStartAction extends Action {
    type: ActionTypes.CHECK_USER_REGISTRATION_START;
    payload: {
        username: string;
        verificationCode: string;
    };
}

export interface CheckIfUserIsActivatedSuccessAction extends Action {
    type: ActionTypes.CHECK_USER_REGISTRATION_SUCCESS;
    payload: UserStatus;
}

export interface CheckIfUserIsActivatedErrorAction extends Action {
    type: ActionTypes.CHECK_USER_REGISTRATION_ERROR;
    payload: {
        errorMessage?: string;
    };
}
